import request from '@/utils/request'

// 获取历史巡视列表
const getInspectionHistoryList = params => {
  return request({
    url: `admin/classroom/inspection/searchClassroomByPage`,
    method: 'post',
    data: params
  })
}
// 巡视历史汇总
const inspectionHistorySummary = params => {
  return request({
    url: `/admin/classroom/inspection/inspectionHistorySummary`,
    method: 'post',
    params
  })
}

// 获取单个教室历史巡视列表
const getClassroomHistoryList = params => {
  return request({
    url: `/admin/classroom/inspection/inspectionHisByPage`,
    method: 'post',
    data: params
  })
}

/**
 * 教室巡视拓展信息
 * @param {*} classroomCode
 * @returns 
 */
const getExtendInfo = params => {
  return request({
    url: `/admin/classroom/inspection/extendInfo`,
    method: 'get',
    params
  })
}

export default {
    getInspectionHistoryList,
    inspectionHistorySummary,
    getClassroomHistoryList,
    getExtendInfo
}
